// @vue/component
export default {
  name: "ActionsPageMain",
};
